import React from 'react';
import logo from './../../images/logo.png';
import AppBarTitle from './AppBarTitle';
import AccountDropdown from './AccountDropdown';
import { Routes, Route, Link } from 'react-router-dom';
import ProjectMenu from './ProjectMenu';

/**
 * The application bar on the top.
 */
export default function AppBar() {
  return (
    <div className="flex h-full w-full bg-white shadow-[0_2px_4px_0_rgba(0,0,0,0.04)]">
      <Link to="/">
        <img
          src={logo}
          alt="Logo"
          className="my-[7px] ml-[15px] mr-[30px] h-[46px]"
        />
      </Link>
      <AppBarTitle />
      <Routes>
        <Route path="project/:id" element={<ProjectMenu />} />
      </Routes>
      <AccountDropdown />
    </div>
  );
}
